<template>
    <!-- Importing Home Component -->
    <forgotComp></forgotComp>
  </template>
  <script>
  import forgotComp from "../../components/Auths/ForgotPassword.vue";
  
  export default {
    name: "Forgot Comp",
    components: { forgotComp },
    computed: {},
    mounted() {},
  };
  </script>
  